import { useLang } from "@/context/LanguageContext";
import { Reveal } from "./Reveal";

export default function Stats() {
  const { t } = useLang();
  return (
    <section className="relative py-16 md:py-20 bg-bg-2 border-b border-line">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-4">
          {t.stats.items.map((s, i) => (
            <Reveal
              key={i}
              delay={i * 0.08}
              className="text-center md:text-left md:px-6 md:border-r md:last:border-r-0 border-line"
              data-testid={`stat-${i}`}
            >
              <div className="font-head font-black tracking-tighter text-brand text-[clamp(2.5rem,5vw,4rem)] leading-none">
                {s.value}
              </div>
              <div className="mt-3 text-sm md:text-base text-ink-2">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
